export default __webpack_public_path__ + "static/media/Pyramide-besoins_pro_n2_securite.9c4e47c4.svg";